/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { PublishApplication200ResponseData } from './PublishApplication200ResponseData'
import {
  PublishApplication200ResponseDataFromJSON,
  PublishApplication200ResponseDataFromJSONTyped,
  PublishApplication200ResponseDataToJSON,
} from './PublishApplication200ResponseData'

/**
 *
 * @export
 * @interface PublishApplication200Response
 */
export interface PublishApplication200Response {
  /**
   *
   * @type {boolean}
   * @memberof PublishApplication200Response
   */
  status: boolean
  /**
   *
   * @type {PublishApplication200ResponseData}
   * @memberof PublishApplication200Response
   */
  data: PublishApplication200ResponseData
}

/**
 * Check if a given object implements the PublishApplication200Response interface.
 */
export function instanceOfPublishApplication200Response(
  value: object
): value is PublishApplication200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function PublishApplication200ResponseFromJSON(
  json: any
): PublishApplication200Response {
  return PublishApplication200ResponseFromJSONTyped(json, false)
}

export function PublishApplication200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublishApplication200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: PublishApplication200ResponseDataFromJSON(json['data']),
  }
}

export function PublishApplication200ResponseToJSON(
  value?: PublishApplication200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: PublishApplication200ResponseDataToJSON(value['data']),
  }
}
